import { Interval } from '@/api-client/models/utilization/Contracts'
export const intervalToLabel =
  (t: (key: string) => string, lower_bound: number = 0, higher_bound: number = Infinity) =>
  <T>(x: Interval<T>): string => {
    if (x.from === undefined && x.to === undefined) {
      return t('general__text__all')
    } else if (x.from !== undefined && x.to === undefined) {
      if (x.from === higher_bound) {
        return `=${higher_bound}`
      }
      return `≥${x.from}`
    } else if (x.from === undefined && x.to !== undefined) {
      if (x.to === lower_bound) {
        return `=${lower_bound}`
      }
      return `≤${x.to}`
    }
    return `${x.from}-${x.to}`
  }
